import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { ConfigService } from './core/config.service';
import { catchError, Subject, takeUntil, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GenericManufacturerSimulationService implements OnDestroy {
  private readonly _destroying$ = new Subject<void>();
  private readonly _backendUri: string = this._configService.config.backendUri;

  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _configService: ConfigService,
  ) {}

  ngOnDestroy() {
    this._destroying$.next();
    this._destroying$.complete();
  }

  getAvailableYearsByAdherent(idAdherent: number) {
    const url = `${this._backendUri}/adherent/${idAdherent}/generic-simulation/years`;

    return this._httpClient.get<number[]>(url).pipe(
      takeUntil(this._destroying$),
      catchError((error: HttpErrorResponse) => throwError(() => error)),
    );
  }

  getGenericSimulationByAdherent(idAdherent: number) {
    const url = `${this._backendUri}/adherent/${idAdherent}/generic-simulation/`;

    return this._httpClient.get<any[]>(`${url}`).pipe(
      takeUntil(this._destroying$),
      catchError((error: HttpErrorResponse) => throwError(() => error)),
    );
  }

  getGenericSimulationByAdherentAndYear(idAdherent: number, year: number) {
    const url = `${this._backendUri}/adherent/${idAdherent}/generic-simulation/${year}`;

    return this._httpClient.get<any[]>(url).pipe(
      takeUntil(this._destroying$),
      catchError((error: HttpErrorResponse) => throwError(() => error)),
    );
  }
}
